import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Field, formValueSelector } from "redux-form";
import { months } from "../../../../../../Utils/months";
import { renderDollar, renderCurrency, renderNumberKG, renderNumberKGDisabled, renderDollarDisabled, renderCurrencyDisabled } from "../../../../../../Utils/renderField/renderField";
import { symbol } from "prop-types";

const LatexTable = (props) => {

    const { currency, change, data_latex } = props;

    const latex_data = (data_latex) ? data_latex : {};

    if (!latex_data) {
        return null;
    }

    const calculateMonthlyValuesLatex = () => {
        var tempData = {};
    
        const getNumber = (v) => parseFloat(v) || 0;
    
        for (let i = 0; i < months.length; i++) {
            const month = months[i];
            const prevMonth = i > 0 ? months[i - 1] : null;
    
            if (!latex_data[month]) continue;
    
            const current = latex_data[month];
            const produccionFca = current.produccion_fca || {};
            const comprasProdExp = current.compras_prod_exp || {};
            const comprasDelMesLocal = current.compras_del_mes_local || {};
            const ajusteInventario = current["ajuste_al_inventario_1%"] || {};
            const ajusteDrc = current.ajuste_por_diferencia_drc_vs_prod || {};
    
            // Heredar inventario inicial
            let inventarioInicial = {};
            if (i === 0) {
                inventarioInicial = current.inventario_inicial || {};
            } else {
                const prevData = tempData[prevMonth] || latex_data[prevMonth] || {};
                inventarioInicial = prevData.inventario_final || {};
            }
    
            const kgsSecos = (
                getNumber(inventarioInicial.kgs_secos) +
                getNumber(produccionFca.kgs_secos) +
                getNumber(comprasProdExp.kgs_secos) +
                getNumber(comprasDelMesLocal.kgs_secos) +
                getNumber(ajusteInventario.kgs_secos) +
                getNumber(ajusteDrc.kgs_secos)
            ).toFixed(2);
    
            const valorTotal = (
                getNumber(inventarioInicial.valor_total) +
                getNumber(produccionFca.valor_total) +
                getNumber(comprasProdExp.valor_total) +
                getNumber(comprasDelMesLocal.valor_total) +
                getNumber(ajusteInventario.valor_total) +
                getNumber(ajusteDrc.valor_total)
            ).toFixed(2);
    
            const costoPromedio = kgsSecos > 0 ? (valorTotal / kgsSecos).toFixed(5) : 0;
    
            // Inventario final (por ahora lo ponemos en cero para mantener consistencia)
            const inventarioFinal = {
                kgs_secos: 0,
                valor_total: 0,
                costo_kg_seco: costoPromedio
            };
    
            // Guardar temporalmente
            tempData[month] = {
                inventario_inicial: {
                    kgs_secos: getNumber(inventarioInicial.kgs_secos),
                    valor_total: getNumber(inventarioInicial.kgs_secos) * getNumber(inventarioInicial.costo_kg_seco),
                    costo_kg_seco: getNumber(inventarioInicial.costo_kg_seco)
                },
                compras_prod_exp: {
                    valor_total: getNumber(comprasProdExp.kgs_secos) * getNumber(comprasProdExp.costo_kg_seco)
                },
                ajuste_al_inventario: {
                    valor_total: getNumber(ajusteInventario.kgs_secos) * getNumber(ajusteInventario.costo_kg_seco)
                },
                cto_promedio_del_inven: {
                    kgs_secos: kgsSecos,
                    valor_total: valorTotal,
                    costo_kg_seco: costoPromedio
                },
                salidas_a_produccion_latex: {
                    kgs_secos: kgsSecos,
                    valor_total: valorTotal,
                    costo_kg_seco: costoPromedio
                },
                inventario_final: inventarioFinal
            };
        }
    
        // Aplicar los cambios al formulario
        for (let i = 0; i < months.length; i++) {
            const month = months[i];
            const temp = tempData[month];
        
            if (!temp) continue;
        
            change(`latex_data.${month}.inventario_inicial.kgs_secos`, temp.inventario_inicial.kgs_secos);
            change(`latex_data.${month}.inventario_inicial.valor_total`, temp.inventario_inicial.valor_total.toFixed(2));
            change(`latex_data.${month}.inventario_inicial.costo_kg_seco`, temp.inventario_inicial.costo_kg_seco);
        
            change(`latex_data.${month}.compras_prod_exp.valor_total`, temp.compras_prod_exp.valor_total.toFixed(2));
            change(`latex_data.${month}.ajuste_al_inventario_1%.valor_total`, temp.ajuste_al_inventario.valor_total.toFixed(2));
        
            change(`latex_data.${month}.cto_promedio_del_inven.kgs_secos`, temp.cto_promedio_del_inven.kgs_secos);
            change(`latex_data.${month}.cto_promedio_del_inven.valor_total`, temp.cto_promedio_del_inven.valor_total);
            change(`latex_data.${month}.cto_promedio_del_inven.costo_kg_seco`, temp.cto_promedio_del_inven.costo_kg_seco);
        
            change(`latex_data.${month}.salidas_a_produccion_latex.kgs_secos`, temp.salidas_a_produccion_latex.kgs_secos);
            change(`latex_data.${month}.salidas_a_produccion_latex.valor_total`, temp.salidas_a_produccion_latex.valor_total);
            change(`latex_data.${month}.salidas_a_produccion_latex.costo_kg_seco`, temp.salidas_a_produccion_latex.costo_kg_seco);
        
            change(`latex_data.${month}.inventario_final.kgs_secos`, temp.inventario_final.kgs_secos);
            change(`latex_data.${month}.inventario_final.valor_total`, temp.inventario_final.valor_total);
            change(`latex_data.${month}.inventario_final.costo_kg_seco`, temp.inventario_final.costo_kg_seco);
        }
    };
    
    const rowDescriptionClassName = "text-left table-fixed-cell-left-0 bg-white text-nowrap tr--border-right tr--border-left";

    return (
        <div className="reports__table-bg">
            <div className="reports-table__container">
                <table className="table mb-0 text-center min-w-500">
                    <thead>
                        <tr>
                            <th rowSpan={2} className="text-left table-fixed-cell-left-0 tr--border-top tr--border-left td--shadow-right">&nbsp;</th>
                            {months.map((_, index) => (
                                <th key={index} colSpan={3} className={`th--border ${index === 0 ? "tr--no-border-left" : ""}`}>{index + 1}</th>
                            ))}
                        </tr>
                        <tr className="tr--no-radius tr--border-top">
                            {months.map((_, index) => (
                                <React.Fragment key={index}>
                                    <th className={index > 0 ? "tr--border-left" : ""}>Kgs Secos</th>
                                    <th>Costo Kg Sec</th>
                                    <th className="tr--border-right">Valor total</th>
                                </React.Fragment>
                            ))}
                        </tr>
                    </thead>
                    <tbody>

                        {/* 🔹 Inventario Inicial */}
                        <tr className="tr--border-top">
                            <td className={rowDescriptionClassName}>Inventario Inicial</td>
                            {months.map((month, index) => {
                                // Si no es enero, obtener el Inventario Final del mes anterior
                                const previousMonth = index > 0 ? months[index - 1] : null;
                                const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                return (
                                    <React.Fragment key={index}>
                                        <td className={monthClass}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`latex_data.${month}.inventario_inicial.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKG}
                                                    className="form-control"
                                                    placeholder='0.0 kg'
                                                    isReport
                                                    onBlur={calculateMonthlyValuesLatex}
                                                />
                                            ) : (
                                                <Field
                                                    name={`latex_data.${previousMonth}.inventario_final.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.0 kg'
                                                />
                                            )}
                                        </td>
                                        <td className={monthClass}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`latex_data.${month}.inventario_inicial.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                    className="form-control"
                                                    placeholder="$ 0.00"
                                                    decimalScale={5}
                                                    onBlur={calculateMonthlyValuesLatex}
                                                />
                                            ) : (
                                                <Field
                                                    name={`latex_data.${previousMonth}.inventario_final.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder="$ 0.00"
                                                    decimalScale={5}
                                                />
                                            )}
                                        </td>
                                        <td className={monthClass + ' tr--border-right'}>
                                            {
                                                index === 0 ? (
                                                    <Field
                                                        name={`latex_data.${month}.inventario_inicial.valor_total`}
                                                        type="text"
                                                        component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                        className="form-control"
                                                        placeholder='$0.00'
                                                    />
                                                ) :
                                                    (
                                                        <Field
                                                            name={`latex_data.${previousMonth}.inventario_final.valor_total`}
                                                            type="text"
                                                            component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                            className="form-control"
                                                            placeholder='$0.00'
                                                        />
                                                    )
                                            }

                                        </td>
                                    </React.Fragment>
                                );
                            })}
                        </tr>
                        {/* 🔹 Compras Prod/Exp */}
                        {[
                            { label: "(+) Producción Fca.", key: "produccion_fca" },
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={rowDescriptionClassName}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`latex_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`latex_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`latex_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )

                                }

                                )}
                            </tr>
                        ))}
                        <tr>
                            <td className={rowDescriptionClassName}>(+) Compras Prod/Exp</td>
                            {months.map((month, index) => {
                                const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                return (
                                    <React.Fragment key={index}>
                                        <td className={monthClass}>
                                            <Field
                                                name={`latex_data.${month}.compras_prod_exp.kgs_secos`}
                                                type="text"
                                                component={renderNumberKG}
                                                className="form-control"
                                                placeholder="0.00 kg"
                                                isReport
                                                onBlur={calculateMonthlyValuesLatex}
                                            />
                                        </td>
                                        <td className={monthClass}>
                                            <Field
                                                name={`latex_data.${month}.compras_prod_exp.costo_kg_seco`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                className="form-control"
                                                placeholder="$ 0.00"
                                                decimalScale={5}
                                                onBlur={calculateMonthlyValuesLatex}
                                            />
                                        </td>
                                        <td className={monthClass + ' tr--border-right'}>
                                            <Field
                                                name={`latex_data.${month}.compras_prod_exp.valor_total`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                className="form-control"
                                                placeholder='$0.00'
                                            />
                                        </td>
                                    </React.Fragment>
                                )
                            }
                            )}
                        </tr>

                        {[
                            { label: "(+) Compras del mes local", key: "compras_del_mes_local" },
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={rowDescriptionClassName}>{row.label}</td>
                                {months.map((month, index) => {

                                    const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`latex_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`latex_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`latex_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                        <tr>
                            <td className={rowDescriptionClassName}>(+) Ajuste al inventario 1%</td>
                            {months.map((month, index) => {
                                const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                return (
                                    <React.Fragment key={index}>
                                        <td className={monthClass}>
                                            <Field
                                                name={`latex_data.${month}.ajuste_al_inventario_1%.kgs_secos`}
                                                type="text"
                                                component={renderNumberKG}
                                                className="form-control"
                                                placeholder="0.00 kg"
                                                isReport
                                                onBlur={calculateMonthlyValuesLatex}
                                            />
                                        </td>
                                        <td className={monthClass}>
                                            <Field
                                                name={`latex_data.${month}.ajuste_al_inventario_1%.costo_kg_seco`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                className="form-control"
                                                placeholder="$ 0.00"
                                                decimalScale={5}
                                                onBlur={calculateMonthlyValuesLatex}
                                            />
                                        </td>
                                        <td className={monthClass + ' tr--border-right'}>
                                            <Field
                                                name={`latex_data.${month}.ajuste_al_inventario_1%.valor_total`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                className="form-control"
                                                placeholder='$0.00'
                                            />
                                        </td>
                                    </React.Fragment>
                                )
                            })}
                        </tr>

                        {[
                            { label: "(+/-) Ajuste por diferencia DRC vs Prod.", key: "ajuste_por_diferencia_drc_vs_prod", style:'' },
                            { label: "Cto. Promedio del Inven.", key: "cto_promedio_del_inven", style: ' celda-totales ' },
                            { label: "Salidas a producción látex", key: "salidas_a_produccion_latex", style:'' },
                            { label: "Inventario Final", key: "inventario_final", style: ' celda-totales ' }

                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={rowDescriptionClassName + row.style}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`latex_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`latex_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={row.style + monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`latex_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const formName = 'CostosMPForm';

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    const data_latex = selector(state, 'latex_data');
    return {
        data_latex,
    };
};


export default connect(mapStateToProps)(LatexTable);
